import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Ping.scss';
export default function Ping({ size = 45, color = 'black', speed = 2, }) {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
        }, children: _jsx("div", { className: styles.inner }) }));
}
